import { render, staticRenderFns } from "./EnergyPredictionComponent.vue?vue&type=template&id=c8d60b48"
import script from "./EnergyPredictionComponent.vue?vue&type=script&lang=js"
export * from "./EnergyPredictionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports